import { Controller } from "stimulus"

const STORAGE_KEY = "desktopNavCollapsed"

export default class extends Controller {
  connect() {
    this.apply(this.chatbotPage || this.stored === "true", false)
  }

  toggle() {
    this.apply(!this.collapsed, !this.chatbotPage)
  }

  expandInto(event) {
    if (!this.collapsed) return

    // This click expands the rail instead of navigating, so stop the
    // event-tracker action listed after us from logging a navigation that
    // never happens (and burning its once-per-element tracked flag).
    event.preventDefault()
    event.stopImmediatePropagation()
    this.apply(false, !this.chatbotPage)

    const item = event.currentTarget.closest(".desktop-nav__item")
    if (!item) return

    item.classList.add("--is-expanded")
    const disclosure = item.querySelector(".desktop-nav__disclosure")
    if (disclosure) disclosure.setAttribute("aria-expanded", "true")
  }

  clearSearch(event) {
    const input = event.target.querySelector(".desktop-nav__search-input")
    if (!input) return

    window.setTimeout(() => {
      input.value = ""
    }, 0)
  }

  apply(collapsed, persist) {
    this.element.classList.toggle("--is-collapsed", collapsed)
    document.body.classList.toggle("app-shell--nav-collapsed", collapsed)

    const trigger = this.element.querySelector(".desktop-nav__collapse")
    if (trigger) trigger.setAttribute("aria-expanded", String(!collapsed))

    if (persist) this.stored = String(collapsed)
  }

  get collapsed() {
    return this.element.classList.contains("--is-collapsed")
  }

  get chatbotPage() {
    return document.querySelector(".main-chat-container") !== null
  }

  get stored() {
    try {
      return window.localStorage.getItem(STORAGE_KEY)
    } catch (error) {
      return null
    }
  }

  set stored(value) {
    try {
      window.localStorage.setItem(STORAGE_KEY, value)
    } catch (error) {
      // no-op
    }
  }
}
